<template>
  <div class="mt-4 d-flex align-items-center">
    <div class="col-3 col-md-5 col-lg-7 text-right">
      {{ $t('partnerPortal.offerFilterOptions.filterBy') }}
    </div>
    <dx-tabs
      v-model="currentValue"
      class="col-9 col-md-7 col-lg-5 small text-uppercase pr-0"
      :tabs-data="tabOptions"
    />
  </div>
</template>

<script>
import { DxTabs } from '@sumcumo/dextra-frontend-component-lib-old'

export default {
  name: 'OpenOfferFilter',
  components: {
    DxTabs,
  },
  props: {
    value: {
      type: String,
      default: 'pending',
    },
  },
  data() {
    return {
      currentValue: this.value,
      tabOptions: [
        {
          value: 'all',
          text: this.$t('partnerPortal.offerFilterOptions.all'),
          id: 'all',
        },
        {
          value: 'pending',
          text: this.$t('partnerPortal.offerFilterOptions.pending'),
          id: 'pending',
        },
        {
          value: 'rejected',
          text: this.$t('partnerPortal.offerFilterOptions.rejected'),
          id: 'rejected',
        },
      ],
    }
  },
  watch: {
    currentValue(newValue) {
      this.$emit('input', newValue)
    },
    value(newValue) {
      this.currentValue = newValue
    },
  },
}
</script>
